import { getIntersection } from '@/Engine/intersections';
import { $ } from '@/Engine/stateInstance';
import { ShelfBrackets } from '@/Engine/Wardrobe/ShelfBrackets';
import { convertItem } from '@/lib/createModule';
import { ShelfSet } from '@/Engine/Wardrobe/ShelfSet';
import { wardrobeTemplates } from '@/Interfaces/common';
import { bracketAccessories } from '@/Constants/accessories';
import { useConfigurationStore } from '@/Store/storeConfiguration';

export const onDragAccessories = (data) => {
    const intersection = getIntersection(
        $.wardrobe.shelves.map((shelf) => [
            shelf.items?.shelfBracketLeft.model,
            shelf.items?.shelfBracketRight.model ])
            .flat()
            .filter((model)=>model),
    );

    if (!intersection.length) return;

    const item = intersection[0].object.parent?.userData.parent;
    if (!item) return;
    const shelfBracket = item as ShelfBrackets;
    const bracketParent = shelfBracket.parent;
    if (!bracketParent)  return;

    const shelfSet = bracketParent as ShelfSet;
    const newTemplate = JSON.parse(JSON.stringify(shelfSet.templates)) as wardrobeTemplates;
    if (bracketAccessories.some(accessory => data.data.name.includes(accessory))) {
        const extraItemTemplate = convertItem(data.data);
        if (extraItemTemplate.compatibilityDepth !== shelfSet.compatibilityDepth) {
            console.log('Несовместимы по глубине ', extraItemTemplate.compatibilityDepth);
            return;
        }
        if (shelfBracket.isLeft) {
            newTemplate.bracketLeftExtra = extraItemTemplate;
        }

        if (shelfBracket.isRight) {
            newTemplate.bracketRightExtra = extraItemTemplate;
        }

        shelfSet.templates = newTemplate;
        shelfSet.updateModels(newTemplate);
        shelfSet.updatePartPosition();
        $.render();
        useConfigurationStore().addKit($.wardrobe.raw);
    }


};
